import React,  {Fragment } from 'react';
import { useForm } from 'react-final-form';
import { FormDataConsumer, useQuery, Loading, Error, SelectInput, required, TextInput, DateInput } from 'react-admin';
import TableCell from '@material-ui/core/TableCell';
import TableRow from '@material-ui/core/TableRow';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import Typography from '@material-ui/core/Typography';
import { makeStyles } from '@material-ui/core/styles';
import allStates from '../donors/AllStates';
import jwt_decode from 'jwt-decode'
import SanitizedTextInput from './SanitizedTextInput';
import { isEmptyObject } from 'jquery';

// Presentational layout only — spacing and widths for the donor identity
// fields. No field, source, label, validation or behaviour is affected.
const useStyles = makeStyles(theme => ({
    section: {
        maxWidth: 960,
        margin: '0.5em auto 1.5em',
        padding: '0.5em 0.75em',
    },
    title: {
        fontWeight: 600,
        color: theme.palette.secondary.main,
        borderBottom: `2px solid ${theme.palette.secondary.main}`,
        paddingBottom: '0.3em',
        marginBottom: '0.75em',
    },
    formTable: {
        width: '100%',
        '& td': {
            verticalAlign: 'top',
            padding: '6px 16px',
            borderBottom: 'none',
        },
        '& tr:hover': {
            backgroundColor: 'transparent',
        },
        '& .MuiFormControl-root': {
            width: '100%',
            minWidth: 140,
        },
    },
}));

let donors =  [];
let record = [];

const genderValues = [
    {
        id: 'Male',
        name: 'Male'
    },
    {
        id: 'Female',
        name: 'Female'
    },
    {
        id: 'Other',
        name: 'Other'
    }
]
    
const getFirstName=(id) => {
    if(id === null) return '';
    
    if(donors.length > 0){
        record = donors.find(rec=> rec.id === id);
        //console.log(record)
        if (record && !isEmptyObject(record)) {
            if (document.getElementById("first_name")){
                if(document.getElementById("first_name").value !== ((record.f_name)?record.f_name : '')){
                    document.getElementById("ssn") && document.getElementById("ssn").focus();
                };
               
            }
            return (record.f_name)?record.f_name : '';
        }
    }
    return '';
}

const getRegId=(id) => {
    if(id === null) return '';
    
    return id;
}

const getLastName=(id) => {
    if(id === null) return '';
    
    if(donors.length > 0){
        record = donors.find(rec=> rec.id === id);
    
        if (record && !isEmptyObject(record)) {
            return (record.l_name)?record.l_name : '';
        }
    }
    return '';
}

const getMiddleName=(id) => {
    if(id === null) return '';
    
    if(donors.length > 0){
        record = donors.find(rec=> rec.id === id);
        
        if (record && !isEmptyObject(record)) {
            return (record.m_name)?record.m_name : '';
        }
    }
    return '';
}

const getApt=(id) => {
    if(id === null) return '';
    
    if(donors.length > 0){
        record = donors.find(rec=> rec.id === id);
        if (record && !isEmptyObject(record)) {
            return (record.apt)?record.apt : '';
        }
    }
    return '';
}

const getStreet=(id) => {
    if(id === null) return '';
    
    if(donors.length > 0){
        record = donors.find(rec=> rec.id === id);
        if (record && !isEmptyObject(record)) {
            return (record.street)?record.street : '';
        }
    }
    return '';
}

const getCity=(id) => {
    if(id === null) return '';
    
    if(donors.length > 0){
        record = donors.find(rec=> rec.id === id);
        if (record && !isEmptyObject(record)) {
            return (record.city)?record.city : '';
        }
    }
    return '';
}

const getGender=(id) => {
    if(id === null) return '';
    
    if(donors.length > 0){
        record = donors.find(rec=> rec.id === id);
        if (record && !isEmptyObject(record)) {
            return (record.gender)?record.gender : '';
        }
    }
    return '';
}

const getState=(id) => {
    if(id === null) return '';
    
    if(donors.length > 0){
        record = donors.find(rec=> rec.id === id);
        if (record && record && !isEmptyObject(record)) {
            return (record.state)?record.state : '';
        }
    }
    return '';
}

const getZip=(id) => {
    if(id === null) return '';
    
    if(donors.length > 0){
        record = donors.find(rec=> rec.id === id);
        if (record && !isEmptyObject(record)) {
            return (record.zip)?record.zip : '';
        }
    }
    return '';
}

const getPhone=(id) => {
    if(id === null) return '';
    
    if(donors.length > 0){
        record = donors.find(rec=> rec.id === id);
        if (record && !isEmptyObject(record)) {
            return (record.don_ph)?record.don_ph : '';
        }
    }
    return '';
}

const getEmail=(id) => {
    if(id === null) return '';
    
    if(donors.length > 0){
        record = donors.find(rec=> rec.id === id);
        if (record && !isEmptyObject(record)) {
            if (document.getElementById("email")){
                if(document.getElementById("email").value !== ((record.email)?record.email : '')){
                    document.getElementById("ssn") && document.getElementById("ssn").focus();
                };
               
            }
            return (record.email)?record.email : '';
        }
    }
    return '';
}


const OrderOrigin = ({ formData, ...rest }) => {
    const form = useForm();
    const classes = useStyles();
   // form.pauseValidation();
    const { data, loading, error } = useQuery({ 
        type: 'getList',
        resource: 'regapproveddons',
        payload:  {
            pagination: { page: 1 , perPage: 50 },
            sort: { field: 'name', order: 'ASC' }
        }
    });
 
    if (loading) return <Fragment><Loading /></Fragment>;
    if (error) return <Error />;
    if (!data) return null;
    donors = data;
   // form.resumeValidation();
   // console.log(donors)
    return (
        <Fragment>
            <div className={classes.section}>
            <Typography variant="subtitle1" className={classes.title}>
                Donor Information
            </Typography>
            <Table className={classes.formTable} >
            <TableBody  >
            <TableRow>
                <TableCell>Registered & Approved donors: </TableCell>
                <TableCell>
                <SelectInput 
                        source="reg_donor"    
                        label="" 
                        choices={donors} 
                        optionText="name" 
                        optionValue="id"
                        onChange = {value =>(
                            form.change('first_name', null),
                            form.change('last_name', null),
                            form.change('middle_name', null),
                            form.change('apt', null),
                            form.change('street', null),
                            form.change('city', null),
                            form.change('zip', null),
                            form.change('state', null),
                            form.change('don_ph', null),
                            form.change('email', null)
                        )
                        }
                        {...rest}
                    />      
                </TableCell>
                <TableCell>
                <SanitizedTextInput source="location"    label="Center Location" defaultValue= {((localStorage.token)?jwt_decode(localStorage.token): null) ? (jwt_decode(localStorage.token)).location : '' }/>
                    <TextInput 
                        source="reg_id"   
                        label="" 
                        validate={required()}
                        value = {
                            formData.reg_id = getRegId(formData.reg_donor)
                        }
                        style={{visibility:'hidden'}}
                        {...rest}
                        />
                </TableCell>
            </TableRow>
            <TableRow >
                <TableCell  ><SanitizedTextInput source="ssn"  label="SSN"  validate={required()}/></TableCell>
                <TableCell  >
                    <SanitizedTextInput 
                        source="first_name"   
                        label="First Name" 
                        validate={required()}
                        value = {
                            formData.first_name = getFirstName(formData.reg_donor)
                        }
                        {...rest}
                        />
                    </TableCell  >
                <TableCell  >
                    <SanitizedTextInput 
                        source="last_name"   
                        label="Last Name" 
                        validate={required()} 
                        value = {
                            formData.last_name = getLastName(formData.reg_donor)
                        }
                        {...rest}
                    />
                </TableCell  >
            </TableRow>
            <TableRow>
                <TableCell  >
                    <SanitizedTextInput 
                        source="middle_name"   
                        label="Middle Name" 
                        value = {
                            formData.middle_name = getMiddleName(formData.reg_donor)
                        }
                        {...rest}
                    />
                </TableCell>
                <TableCell  ><DateInput source="dob"    label="DOB" validate={required()} locales="en-us"/></TableCell>
                <TableCell  >
                    <SelectInput 
                        source="gender" 
                        lable="Gender"  
                        choices={genderValues} 
                        validate={required()} 
                        value = {
                            formData.gender = getGender(formData.reg_donor)
                        }
                        {...rest}
                    />
                </TableCell>
            </TableRow>
            <TableRow>
                <TableCell  >
                    <TextInput 
                        source="apt"   
                        label="Apt/Suit#" 
                        value = {
                            formData.apt = getApt(formData.reg_donor)
                        }
                        {...rest}
                    />
                </TableCell>
                <TableCell  >
                    <SanitizedTextInput 
                        source="street"   
                        label="Street" 
                        validate={required()} 
                        value = {
                            formData.street = getStreet(formData.reg_donor)
                        }
                        {...rest}
                    />
                </TableCell>
                <TableCell  >
                    <SanitizedTextInput 
                        source="city"   
                        label="City" 
                        validate={required()}
                        value = {
                            formData.city = getCity(formData.reg_donor)
                        }
                        {...rest}
                    />
                    </TableCell>
            </TableRow>
            <TableRow>
                <TableCell  >
                    <SanitizedTextInput 
                        source="zip"    
                        label="Zip" 
                        value = {
                            formData.zip = getZip(formData.reg_donor)
                        }
                        {...rest}
                    />
                </TableCell>
                <TableCell  >
                    <SelectInput 
                        source="state"  
                        label="State" 
                        choices={allStates}
                        value = {
                            formData.state = getState(formData.reg_donor)
                        }
                        {...rest}
                    />
                </TableCell>
                <TableCell  >
                    <TextInput 
                        source="don_ph"  
                        label="Phone"
                        value = {
                            formData.don_ph = getPhone(formData.reg_donor)
                        }
                        {...rest}
                    />
                </TableCell>
            </TableRow>
            <TableRow>
                <TableCell colSpan='3'>
                    <TextInput 
                        source="email"   
                        label="Email" 
                        style = {{width: 300}} 
                        value = {
                            formData.email = getEmail(formData.reg_donor)
                        }
                        {...rest}
                    />
                </TableCell>
            </TableRow>
            </TableBody>
         </Table>
         </div>
        </Fragment>
        );

};
const RegApprovedDonors = ({...props}) => (

    <FormDataConsumer>
        {formDataProps => (
            <OrderOrigin {...formDataProps} />
        )}
    </FormDataConsumer>
);

export default RegApprovedDonors